import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "crud-user flex flex-column" }
const _hoisted_2 = { class: "flex flex-align-center mb" }
const _hoisted_3 = {
  key: 0,
  class: "big icons8-user mr"
}
const _hoisted_4 = {
  key: 1,
  class: "big icons8-waste mr"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "mb" }
const _hoisted_7 = {
  key: 1,
  class: "grid-radio-group"
}
const _hoisted_8 = { class: "crud-user__label" }
const _hoisted_9 = { class: "crud-user__radio-grid" }
const _hoisted_10 = ["value", "checked", "onChange"]
const _hoisted_11 = { class: "flex flex-column" }
const _hoisted_12 = { class: "description gray3--text mt-05" }
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = { class: "crud-user__field" }
const _hoisted_16 = { class: "crud-user__label" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "error-message"
}
const _hoisted_19 = { class: "crud-user__field" }
const _hoisted_20 = { class: "crud-user__label" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = { class: "crud-user__field" }
const _hoisted_24 = { class: "crud-user__label" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "error-message"
}
const _hoisted_28 = { class: "crud-user__field" }
const _hoisted_29 = { class: "crud-user__label" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 3,
  class: "label theme--ligth"
}
const _hoisted_33 = { class: "crud-user__field flex-grow-1" }
const _hoisted_34 = { class: "crud-user__label" }
const _hoisted_35 = ["onUpdate:modelValue", "disabled"]
const _hoisted_36 = { value: "" }
const _hoisted_37 = ["value"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "button-label" }
const _hoisted_41 = { class: "crud-user__label" }
const _hoisted_42 = { class: "crud-user__inline-radios" }
const _hoisted_43 = { class: "crud-user__radio" }
const _hoisted_44 = ["checked", "disabled"]
const _hoisted_45 = { class: "crud-user__radio" }
const _hoisted_46 = ["checked", "disabled"]
const _hoisted_47 = { class: "input-label" }
const _hoisted_48 = { class: "sublabel" }
const _hoisted_49 = { class: "grid" }
const _hoisted_50 = { class: "crud-user__field no-padding" }
const _hoisted_51 = ["disabled", "placeholder"]
const _hoisted_52 = {
  key: 0,
  class: "error-message"
}
const _hoisted_53 = {
  key: 7,
  class: "mb-2"
}
const _hoisted_54 = ["disabled", "checked", "onChange"]
const _hoisted_55 = {
  key: 8,
  class: "notification"
}
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = { class: "mb" }
const _hoisted_58 = { class: "crud-user__label" }
const _hoisted_59 = { class: "crud-user__inline-radios" }
const _hoisted_60 = { class: "crud-user__radio" }
const _hoisted_61 = ["checked"]
const _hoisted_62 = { class: "crud-user__radio" }
const _hoisted_63 = ["checked"]
const _hoisted_64 = {
  key: 9,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 10,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 11,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.action !== _ctx.userActions.Inactive)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "icons8-delete close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.action === _ctx.userActions.Create || _ctx.action === _ctx.userActions.Update)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (_ctx.action === _ctx.userActions.Delete)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("", true),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.getTitleText)), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.getDescriptionText)), 1),
    (_ctx.action === _ctx.userActions.Create)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("MY_ENVIRONMENT.PROFILE.ROLE")), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioUserRoles, (role) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "crud-user__radio-card",
                key: role.id
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "user-role",
                  value: role.value,
                  checked: _ctx.user.roleName === role.value,
                  onChange: ($event: any) => (_ctx.user.roleName = role.value)
                }, null, 40, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(role.titleKey)), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(role.descriptionKey)), 1)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.errorMessage("RoleName"))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errorMessage("RoleName")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$requiredLabel("MY_ENVIRONMENT.PROFILE.FIRST_NAME")), 1),
        _withDirectives(_createElementVNode("input", {
          class: "crud-user__input",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.firstName) = $event)),
          disabled: !_ctx.isUpdateOrCreateAction
        }, null, 8, _hoisted_17), [
          [_vModelText, _ctx.user.firstName]
        ]),
        (_ctx.errorMessage("FirstName"))
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.errorMessage("FirstName")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_19, [
        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$requiredLabel("MY_ENVIRONMENT.PROFILE.LAST_NAME")), 1),
        _withDirectives(_createElementVNode("input", {
          class: "crud-user__input",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lastName) = $event)),
          disabled: !_ctx.isUpdateOrCreateAction
        }, null, 8, _hoisted_21), [
          [_vModelText, _ctx.user.lastName]
        ]),
        (_ctx.errorMessage("LastName"))
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.errorMessage("LastName")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_23, [
        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$requiredLabel(_ctx.isUpdateOrCreateAction ? "MY_ENVIRONMENT.USER.EMAIL_LANGUAGE" : "MY_ENVIRONMENT.USER.EMAIL_LANGUAGE_DISABLED_LABEL")), 1),
        _withDirectives(_createElementVNode("select", {
          class: "crud-user__input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.language) = $event)),
          disabled: !_ctx.isUpdateOrCreateAction
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localeOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.id,
              value: option.value
            }, _toDisplayString(option.title), 9, _hoisted_26))
          }), 128))
        ], 8, _hoisted_25), [
          [_vModelSelect, _ctx.user.language]
        ]),
        (_ctx.errorMessage("language"))
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.errorMessage("language")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_28, [
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$requiredLabel("COMMON.EMAIL")), 1),
        _withDirectives(_createElementVNode("input", {
          class: "crud-user__input",
          type: "email",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.userName) = $event)),
          disabled: _ctx.action !== _ctx.userActions.Create
        }, null, 8, _hoisted_30), [
          [_vModelText, _ctx.user.userName]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages(["UserName", "Email"]), (message) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "error-message",
            key: message
          }, _toDisplayString(message), 1))
        }), 128))
      ])
    ]),
    (_ctx.currentUserIsSuperAdmin && _ctx.selectedRolIsNotSupport)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_31))
      : _createCommentVNode("", true),
    ((_ctx.showCheckboxOfCompanies || _ctx.currentUserIsSuperAdmin) && _ctx.selectedRolIsNotSupport)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_32, _toDisplayString(_ctx.$t(_ctx.showCheckboxOfCompanies ? "COMPANY.ADD_COMPANY.ACCESS_TO" : "COMPANY.ADD_COMPANY.TITLE")), 1))
      : _createCommentVNode("", true),
    (_ctx.currentUserIsSuperAdmin && _ctx.selectedRolIsNotSupport)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.user.companies, (company, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex flex-align-center",
            key: i
          }, [
            _createElementVNode("label", _hoisted_33, [
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$requiredLabel("COMMON.COMPANY")), 1),
              _withDirectives(_createElementVNode("select", {
                class: "crud-user__input",
                "onUpdate:modelValue": ($event: any) => ((company.id) = $event),
                disabled: !_ctx.isUpdateOrCreateAction
              }, [
                _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t("COMPANY.ADD_COMPANY.PLACEHOLDER")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companiesWithDisplayName, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.id,
                    value: option.id
                  }, _toDisplayString(option.displayText), 9, _hoisted_37))
                }), 128))
              ], 8, _hoisted_35), [
                [_vModelSelect, company.id]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages([`$.companyIds[${i}]`, "CompanyIds"]), (message) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "error-message",
                  key: message
                }, _toDisplayString(message), 1))
              }), 128))
            ]),
            (_ctx.user.companies.length > 1 && _ctx.isUpdateOrCreateAction)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "crud-user__remove-company ml-2",
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeCompanyAtIndex(i))
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "icons8-waste" }, null, -1)
                ]))], 8, _hoisted_38))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.isUpdateOrCreateAction && _ctx.currentUserIsSuperAdmin  && _ctx.selectedRolIsNotSupport)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          class: "flex-self-start flex mb-2",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addAnotherCompany())),
          type: "button",
          disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights)
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "icons8-city-buildings mr-05 accent--text" }, null, -1)),
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('COMPANY.ADD_COMPANY.BUTTON')), 1)
        ], 8, _hoisted_39))
      : _createCommentVNode("", true),
    (_ctx.user.companies.length > 1 && _ctx.currentUserIsSuperAdmin)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("COMPANY.COMBINE")), 1),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("label", _hoisted_43, [
              _createElementVNode("input", {
                type: "radio",
                name: "combine-companies",
                checked: _ctx.user.combineCompanies === true,
                disabled: !_ctx.isUpdateOrCreateAction,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.combineCompanies = true))
              }, null, 40, _hoisted_44),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("COMMON.YES")), 1)
            ]),
            _createElementVNode("label", _hoisted_45, [
              _createElementVNode("input", {
                type: "radio",
                name: "combine-companies",
                checked: _ctx.user.combineCompanies === false,
                disabled: !_ctx.isUpdateOrCreateAction,
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.combineCompanies = false))
              }, null, 40, _hoisted_46),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("COMMON.NO")), 1)
            ])
          ]),
          (_ctx.user.combineCompanies && _ctx.currentUserIsSuperAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$requiredLabel('COMPANY.CORPORATE')), 1),
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('COMPANY.CORPORATE_DESCRIPTION')), 1),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, [
                    _withDirectives(_createElementVNode("input", {
                      class: "crud-user__input",
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.companyDisplayName) = $event)),
                      disabled: !_ctx.isUpdateOrCreateAction,
                      placeholder: _ctx.$t("COMPANY.CORPORATE")
                    }, null, 8, _hoisted_51), [
                      [_vModelText, _ctx.user.companyDisplayName]
                    ]),
                    (_ctx.errorMessage("companyDisplayName"))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.errorMessage("companyDisplayName")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showCheckboxOfCompanies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companiesWithDisplayName, (company, i) => {
            return (_openBlock(), _createElementBlock("label", {
              class: "crud-user__checkbox",
              key: i
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                disabled: _ctx.action !== _ctx.userActions.Create,
                checked: !!_ctx.user.companies.find(com =>com.id === company.id),
                onChange: ($event: any) => (_ctx.updateCompanies(company))
              }, null, 40, _hoisted_54),
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "crud-user__checkbox-box" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(company.displayText), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages([`$.companyIds[${i}]`, "CompanyIds"]), (message) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "error-message",
                  key: message
                }, _toDisplayString(message), 1))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ((_ctx.action === _ctx.userActions.Create || _ctx.action === _ctx.userActions.Update) && _ctx.isAdminOrManager)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("h3", _hoisted_56, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.GENERAL_NOTIFICATION')), 1),
          _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.GENERAL_NOTIFICATION_TEXT')), 1),
          _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("MY_ENVIRONMENT.PROFILE.RECEIVE_GENERAL_NOTIFICATION")), 1),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("label", _hoisted_60, [
              _createElementVNode("input", {
                type: "radio",
                name: "enabled-general-notification",
                checked: _ctx.user.enabledGeneralNotification === true,
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.user.enabledGeneralNotification = true))
              }, null, 40, _hoisted_61),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("COMMON.YES")), 1)
            ]),
            _createElementVNode("label", _hoisted_62, [
              _createElementVNode("input", {
                type: "radio",
                name: "enabled-general-notification",
                checked: _ctx.user.enabledGeneralNotification === false,
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.enabledGeneralNotification = false))
              }, null, 40, _hoisted_63),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("COMMON.NO")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.action === _ctx.userActions.Inactive || _ctx.action === _ctx.userActions.Active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("button", {
            class: "crud-user__secondary",
            type: "button",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_65),
          _createElementVNode("button", {
            class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
            type: "button",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_66)
        ]))
      : (_ctx.action === _ctx.userActions.Delete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _createElementVNode("button", {
              class: "crud-user__secondary",
              type: "button",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_68),
            _createElementVNode("button", {
              class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
              type: "button",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
              disabled: _ctx.isLoading
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 1),
              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "icons8-waste" }, null, -1))
            ], 10, _hoisted_69)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("button", {
              class: _normalizeClass(["text-button", { "is-loading": _ctx.isLoading }]),
              type: "button",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 11, _hoisted_71),
            _createElementVNode("button", {
              class: _normalizeClass(["crud-user__primary ml-2", { "is-loading": _ctx.isLoading }]),
              type: "button",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_72)
          ]))
  ]))
}